import * as actions from '../actions';
import { BOOT_SUCCEEDED } from '../actions/boot';
import { LearnRecap } from '../middlewares/boot/getLearnRecapAsPromise';

export type LearnRecapState = LearnRecap | null;

export default (state = null, action: actions.Action): LearnRecapState => {
  switch (action.type) {
    case BOOT_SUCCEEDED:
      return action.learnRecap;
    default:
      return state;
  }
};
